<template>
  <div class="Review">
    <div
      v-for="(reviewComponent, name) in review"
      :key="name"
      :class="name"
    >
      <p class="ratings">
        <strong v-if="hasLabels">{{ $t(labels[name]) }}</strong>
        <small class="float-right">
          {{ rating(reviewComponent, name) }}/5&nbsp;
          <i
            class="material-icons"
            v-for="(star, index) in stars(reviewComponent, name)"
            :key="index"
            :class="{ 'text-warning': star === 'full' || 'half' }"
          >{{ (star === 'full') ? 'star' : ((star === 'empty') ? 'star_border' : 'star_half') }}</i>
        </small>
      </p>
      <p v-html="getText(reviewComponent)"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Review',

  props: {
    options: Object,
    review: Object
  },

  data() {
    return {
      labels: {
        gfuReview: 'reviews.aboutGfu',
        seminarReview: 'reviews.aboutSeminar',
        trainerReview: 'reviews.aboutTrainer'
      }
    }
  },

  computed: {
    hasLabels() {
      return Object.keys(this.review).length > 1;
    }
  },

  methods: {
    getText(review) {
      if (!review.text) {
        return ' - ';
      }
      return review.text.replace(/\\n/g, "<br>");
    },

    stars(review, name) {
      let stars = [];
      let rating = this.rating(review, name);
      for (let i = 1; i < 6; i++) {
        if (i <= rating) {
          stars.push('full')
        } else {
          (rating % 1 == 0) ? stars.push('empty') : ((i - rating == 0.5) ? stars.push('half') : stars.push('empty'))
        }
      }
      return stars;
    },

    rating(review, type) {
      if (type === "trainerReview") {
        return this.trainerRating(review);
      }
      return review.rating;
    },

    trainerRating(review) {
      return (review.methodRating + review.subjectRating) / 2;
    },
  },

}
</script>

<style>
.material-icons {
  display: inline-block;
  font-size: 1.2em;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.review .card {
  font-size: 14px;
  padding: 15px 15px 20px 50px;
  border-bottom-left-radius: 0px;
}

.review .card::before {
  content: "”";
  color: rgb(3, 56, 120);
  font-size: 80px;
  line-height: .7;
  position: absolute;
  left: 15px;
}


.review .review-ref {
  margin: 15px 0 0 0;
  display: block;
}

.review .review-ref svg {
  padding-right: 5px;
  padding-bottom: 2px;
}

.ratings small .material-icons {
  vertical-align: sub;

}

.ratings small .material-icons.text-warning {
  color: #fdc41f !important;
}

.review-ref {
  margin: 15px 0 0 0;
  display: block;
  font-size: 12px;
}

.ratings small {
  padding-left: 20px;
  font-size: 11px;
  color: #aaa;
}

.trainerReview small {
  font-size: 14px;
  width: 100%;
  text-align: right;
  padding-bottom: 5px;
}

.gfuReview+.seminarReview,
.gfuReview+.trainerReview,
.seminarReview+.trainerReview {
  margin-top: 1.5rem;
}
</style>
